import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { HTTP_DEFAULT_TIMEOUT } from '../constant/constant';

export function  requestTimeoutHttpInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn ): Observable<HttpEvent<unknown>>{
    return next(req).pipe(timeout(HTTP_DEFAULT_TIMEOUT));
}
